import wpaType12 from './wapType_12';
/**
 * 位置示意图
 * 1   2   3
 * 4   5   6
 * 7   8   9
 */
const POSITION = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
};

/**
 * WPA类型
 * 1 - 图标型
 * 2 - 链接型
 * 3 - DOM型
 */
const KIND = {
    1: 1,
    2: 2,
    3: 3,
    4: 4,
};

/**
 * WPA通路类型
 * 1 - QQ接待
 * 3 - 公众号推广
 * 4 - 群推广
 * 5 - 员工推广
 * 7 - 网页接待
 * 8 - 企点接待
 */
const CATE = {
    1: 1,
    3: 3,
    4: 4,
    5: 5,
    7: 7,
    8: 8,
    10: 10,
    11: 11,
    12: 12,
};

/**
 * WPA使用场景
 * 0 - 网页样式
 * 1 - 公众号图文样式
 * 2 - 手机网页样式
 * 3 - 链接/二维码
 */
const SCENE = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
};

/**
 * WPA部署位置
 * 0 - 挂载位置(默认)
 * 1 - 电脑网页
 * 2 - 手机网页
 * 3 - 线下物料
 * 4 - 短信邮件
 * 5 - 公众号图文
 * 6 - 其他
 */
const DEPLOY = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
};

export default {
    1: {
        /* QQ接待 */
        1: {
            1: {
                kind: KIND[1],
                cate: CATE[1],
                type: 1,
                scene: SCENE[0],
                required: ['btnText', 'theme', 'role', 'middlePage', 'deployList'],
                role: ['roleQQ'],
                theme: ['#ffffff', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                defaults: {
                    btnText: '在线咨询',
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    btnText: 4,
                },
                size: {
                    w: 96,
                    h: 30,
                },
            },
            2: {
                kind: KIND[1],
                cate: CATE[1],
                type: 2,
                scene: SCENE[0],
                required: ['btnText', 'theme', 'role', 'middlePage', 'deployList'],
                role: ['roleQQ'],
                theme: ['#ffffff', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                defaults: {
                    btnText: '在线咨询',
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    btnText: 4,
                },
                size: {
                    w: 150,
                    h: 45,
                },
            },
            3: {
                kind: KIND[1],
                cate: CATE[1],
                type: 3,
                order: 3,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['title', 'signature', 'role', 'avatar', 'location', 'middlePage', 'deployList'],
                avatarType: 2,
                role: ['roleQQ'],
                defaults: {
                    title: '在线咨询',
                    signature: '服务时间 9:00-20:00',
                    location: {
                        v: {
                            type: 2,
                            px: 0,
                        },
                        h: {
                            type: 3,
                            px: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    title: 5,
                    signature: 10,
                },
                size: {
                    w: 255,
                    h: 85,
                },
            },
            4: {
                kind: KIND[1],
                cate: CATE[1],
                type: 4,
                order: 4,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['btnText', 'theme', 'role', 'location', 'middlePage', 'deployList'],
                role: ['roleQQ'],
                theme: ['#ffffff', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                defaults: {
                    btnText: '在线咨询',
                    location: {
                        v: {
                            type: 2,
                            px: 0,
                        },
                        h: {
                            type: 3,
                            px: 10,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    btnText: 4,
                },
                posHint: 1,
                size: {
                    w: 70,
                    h: 70,
                },
            },
            5: {
                kind: KIND[1],
                cate: CATE[1],
                type: 5,
                order: 5,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['title', 'btnBgColor', 'avatar', 'btnText', 'role', 'location', 'middlePage', 'deployList'],
                avatarType: 1,
                role: ['roleQQ'],
                btnBgColor: ['#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                defaults: {
                    title: '在线咨询',
                    btnText: 'QQ交谈',
                    location: {
                        v: {
                            type: 2,
                            px: 0,
                        },
                        h: {
                            type: 3,
                            px: 10,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    btnText: 4,
                    title: 6,
                },
                posHint: 1,
                size: {
                    w: 106,
                    h: 165,
                },
            },
            6: {
                kind: KIND[1],
                cate: CATE[1],
                type: 6,
                order: 6,
                scene: SCENE[0],
                defaultPosition: POSITION[9],
                required: [
                    'title',
                    'signature',
                    'btnBgColor',
                    'avatar',
                    'btnText',
                    'role',
                    'location',
                    'middlePage',
                    'deployList',
                ],
                avatarType: 3,
                role: ['roleQQ'],
                btnBgColor: ['#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                defaults: {
                    title: '在线咨询',
                    btnText: 'QQ交谈',
                    signature: '您好，请问有什么可以帮到您？',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 10,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    btnText: 4,
                    signature: 40,
                    title: 8,
                },
                posHint: 2,
                size: {
                    w: 404,
                    h: 200,
                },
            },
            7: {
                kind: KIND[1],
                cate: CATE[1],
                type: 7,
                order: 3,
                scene: SCENE[2],
                defaultPosition: POSITION[9],
                required: ['role', 'location', 'middlePage', 'deployList'],
                role: ['roleQQ'],
                pos: 'rb',
                defaults: {
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 44,
                    h: 45,
                },
            },
            8: {
                kind: KIND[1],
                cate: CATE[1],
                type: 8,
                order: 4,
                scene: SCENE[2],
                defaultPosition: POSITION[9],
                required: ['role', 'location', 'middlePage', 'deployList'],
                role: ['roleQQ'],
                pos: 'rb',
                defaults: {
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 125,
                    h: 39,
                },
            },
            9: {
                kind: KIND[1],
                cate: CATE[1],
                type: 9,
                order: 5,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: [
                    'title',
                    'signature',
                    'theme',
                    'position',
                    'avatar',
                    'role',
                    'location',
                    'middlePage',
                    'deployList',
                ],
                avatarType: 1,
                theme: ['', '#000000', '#f0f0f0'],
                role: ['roleQQ'],
                tpl: 3,
                tplOptions: {
                    iconList: ['icon-qq'],
                    eventList: ['callChat'],
                    hasAvatar: 1,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            10: {
                kind: KIND[1],
                cate: CATE[1],
                type: 10,
                order: 6,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'theme', 'position', 'role', 'location', 'middlePage', 'deployList'],
                theme: ['', '#000000', '#f0f0f0'],
                role: ['roleQQ'],
                tpl: 3,
                tplOptions: {
                    iconList: ['icon-qq'],
                    eventList: ['callChat'],
                    hasAvatar: 0,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            13: {
                kind: KIND[1],
                cate: CATE[1],
                type: 13,
                scene: SCENE[1],
                required: ['title', 'signature', 'avatar', 'role', 'deployList'],
                avatarType: 1,
                role: ['roleQQ'],
                isInQQ: 1,
                tpl: 4,
                tplOptions: {
                    iconList: ['icon-qq'],
                    eventList: ['callChat'],
                    hasAvatar: 1,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                suitable: 'qq',
                size: {
                    w: '100%',
                    h: 70,
                },
            },
            15: {
                kind: KIND[1],
                cate: CATE[1],
                type: 15,
                scene: SCENE[1],
                required: ['title', 'signature', 'avatar', 'role', 'deployList'],
                isQRcode: 1,
                avatarType: 2,
                theme: ['#ffffff'],
                role: ['roleQQ'],
                defaults: {
                    title: '在线咨询',
                    signature: '长按二维码在线咨询，随时了解最新动态。',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 26,
                    title: 8,
                },
                suitable: 'wx',
                size: {
                    w: '100%',
                    h: 135,
                },
            },
            17: {
                kind: KIND[1],
                cate: CATE[1],
                type: 17,
                order: 2,
                scene: SCENE[0],
                required: ['custom', 'role', 'middlePage', 'deployList'],
                role: ['roleQQ'],
                defaults: {
                    btnText: '在线咨询',
                    custom: {
                        customType: 2, // 1 - 自定义DOM 2 - 自定义图片
                        domId: '', // 自定义DOM ID
                        open: 1, // 1 - 当前页打开 2 - 新窗口打开
                        customImg: {
                            zoom: 0, // 0 - 不适应 1 - 水平适应 2 - 上下适应
                            url: '',
                            h: {
                                type: 3, // 1 - 左 2 - 中 3 - 右
                                px: 0, // 偏移量
                            },
                            v: {
                                type: 3, // 1 - 上 2 - 中 3 - 下
                                px: 0, // 偏移量
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            18: {
                kind: KIND[1],
                cate: CATE[1],
                type: 18,
                order: 2,
                scene: SCENE[2],
                required: ['custom', 'role', 'middlePage', 'deployList'],
                role: ['roleQQ'],
                defaults: {
                    btnText: '在线咨询',
                    custom: {
                        customType: 2, // 1 - 自定义DOM 2 - 自定义图片
                        domId: '', // 自定义DOM ID
                        open: 1, // 1 - 当前页打开 2 - 新窗口打开
                        customImg: {
                            zoom: 0, // 0 - 不适应 1 - 水平适应 2 - 上下适应
                            url: '',
                            h: {
                                type: 3, // 1 - 左 2 - 中 3 - 右
                                px: 0, // 偏移量
                            },
                            v: {
                                type: 3, // 1 - 上 2 - 中 3 - 下
                                px: 0, // 偏移量
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            19: {
                kind: KIND[1],
                cate: CATE[1],
                type: 19,
                order: 1,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['theme', 'role', 'location', 'middlePage', 'deployList'],
                theme: ['#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                avatarType: 2,
                role: ['roleQQ'],
                defaults: {
                    title: '',
                    signature: '',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    title: 5,
                    signature: 10,
                },
                size: {
                    w: 60,
                    h: 60,
                },
            },
            20: {
                kind: KIND[1],
                cate: CATE[1],
                type: 20,
                order: 1,
                scene: SCENE[2],
                defaultPosition: POSITION[6],
                required: ['theme', 'role', 'location', 'middlePage', 'deployList'],
                theme: ['#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                avatarType: 2,
                role: ['roleQQ'],
                defaults: {
                    title: '',
                    signature: '',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    title: 5,
                    signature: 10,
                },
                size: {
                    w: 60,
                    h: 60
                }
            }
        },
        /* 公众号推广 */
        3: {
            2: {
                kind: KIND[1],
                cate: CATE[3],
                type: 2,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'theme', 'avatar', 'role', 'position', 'location', 'deployList'],
                role: ['rolePUB'],
                theme: ['', '#000000', '#f0f0f0'],
                defaults: {
                    title: '企业公众号',
                    signature: '关注了解企业最新动态',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                size: {
                    w: '100%',
                    h: 70,
                },
            },
            3: {
                kind: KIND[1],
                cate: CATE[3],
                type: 3,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'theme', 'position', 'role', 'location', 'deployList'],
                role: ['rolePUB'],
                theme: ['', '#000000', '#f0f0f0'],
                defaults: {
                    title: '企业公众号',
                    signature: '关注了解企业最新动态',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                size: {
                    w: '100%',
                    h: 70,
                },
            },
        },
        /* 群推广 */
        4: {
            1: {
                kind: KIND[1],
                cate: CATE[4],
                type: 1,
                scene: SCENE[0],
                defaultPosition: POSITION[9],
                required: ['title', 'signature', 'btnBgColor', 'btnText', 'avatar', 'role', 'location', 'deployList'],
                role: ['roleGROUP'],
                btnBgColor: ['#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                avatarType: 1,
                defaults: {
                    title: '欢迎加群',
                    btnText: '加入群组',
                    signature: '在这里，您可以随时随地分享我们产品的使用心得，欢迎加群！',
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 3,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    btnText: 4,
                    signature: 32,
                    title: 8,
                },
                posHint: 2,
                size: {
                    w: 404,
                    h: 200,
                },
            },
            2: {
                kind: KIND[1],
                cate: CATE[4],
                type: 2,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'theme', 'role', 'position', 'location', 'deployList'],
                role: ['roleGROUP'],
                theme: ['', '#000000', '#f0f0f0'],
                defaults: {
                    title: '企业交流群',
                    signature: '用户交流分享使用心得',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                size: {
                    w: '100%',
                    h: 70,
                },
            },
            3: {
                kind: KIND[1],
                cate: CATE[4],
                type: 3,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'theme', 'position', 'avatar', 'role', 'location', 'deployList'],
                role: ['roleGROUP'],
                avatarType: 1,
                theme: ['', '#000000', '#f0f0f0'],
                defaults: {
                    title: '企业交流群',
                    signature: '用户交流分享使用心得',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                size: {
                    w: '100%',
                    h: 70,
                },
            },
            4: {
                kind: KIND[1],
                cate: CATE[4],
                type: 4,
                scene: SCENE[1],
                required: ['title', 'signature', 'avatar', 'role', 'deployList'],
                role: ['roleGROUP'],
                avatarType: 1,
                isInQQ: 1,
                tpl: 5,
                tplOptions: {
                    eventList: ['callAddGroup'],
                    fixedBtnText: '群组',
                    hasAvatar: 1,
                },
                defaults: {
                    title: '企业交流群',
                    signature: '用户交流分享使用心得',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                suitable: 'qq',
                size: {
                    w: '100%',
                    h: 70,
                },
            },
        },
        /* 员工推广 */
        5: {
            /* 电脑网页加好友接待组件暂不开放 */
            /*
            1: {
                kind: KIND[1],
                cate: CATE[5],
                type: 1,
                scene: SCENE[0],
                defaultPosition: POSITION[9],
                required: ['title', 'signature', 'btnBgColor', 'btnText', 'avatar', 'role', 'location'],
                avatarType: 3,
                role: ['roleKFEXT'],
                btnBgColor: ['#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                defaults: {
                    title: '咨询顾问',
                    btnText: '加为好友',
                    signature: '您身边的贴心助理，欢迎随时咨询',
                    location: {
                        v: {
                            type: 3,
                            px: 0
                        },
                        h: {
                            type: 3,
                            px: 0
                        }
                    }
                },
                limit: {
                    btnText: 4,
                    signature: 40,
                    title: 8
                },
                posHint: 2,
                size: {
                    w: 404,
                    h: 200
                }
            },
            */
            2: {
                kind: KIND[1],
                cate: CATE[5],
                type: 2,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'theme', 'role', 'position', 'location', 'deployList'],
                role: ['roleKFEXT'],
                theme: ['', '#000000', '#f0f0f0'],
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                size: {
                    w: '100%',
                    h: 70,
                },
            },
            3: {
                kind: KIND[1],
                cate: CATE[5],
                type: 3,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'theme', 'position', 'avatar', 'role', 'location', 'deployList'],
                avatarType: 1,
                role: ['roleKFEXT'],
                theme: ['', '#000000', '#f0f0f0'],
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                size: {
                    w: '100%',
                    h: 70,
                },
            },
            4: {
                kind: KIND[1],
                cate: CATE[5],
                type: 4,
                scene: SCENE[1],
                required: ['title', 'signature', 'avatar', 'role', 'deployList'],
                avatarType: 1,
                role: ['roleKFEXT'],
                isInQQ: 1,
                tpl: 5,
                tplOptions: {
                    eventList: ['callAddPal'],
                    hasAvatar: 1,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    signature: 10,
                    title: 8,
                },
                suitable: 'qq',
                size: {
                    w: '100%',
                    h: 70,
                },
            },
        },
        /* 网页接待 */
        7: {
            1: {
                kind: KIND[1],
                cate: CATE[7],
                type: 1,
                order: 3,
                scene: SCENE[2],
                defaultPosition: POSITION[9],
                required: ['theme', 'role', 'location', 'deployList'],
                role: ['roleIM'],
                theme: ['#ffffff', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                pos: 'rb',
                defaults: {
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 44,
                    h: 45,
                },
            },
            2: {
                kind: KIND[1],
                cate: CATE[7],
                type: 2,
                order: 4,
                scene: SCENE[2],
                defaultPosition: POSITION[9],
                required: ['theme', 'role', 'btnText', 'location', 'deployList'],
                role: ['roleIM'],
                theme: ['#ffffff', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                limit: {
                    btnText: 4,
                },
                defaults: {
                    btnText: '点我咨询',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                pos: 'rb',
                size: {
                    w: 125,
                    h: 39,
                },
            },
            3: {
                kind: KIND[1],
                cate: CATE[7],
                type: 3,
                order: 5,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: [
                    'title',
                    'signature',
                    'theme',
                    'role',
                    'btnText',
                    'avatar',
                    'position',
                    'location',
                    'deployList',
                ],
                avatarType: 1,
                role: ['roleIM'],
                theme: ['', '#000000', '#f0f0f0'],
                limit: {
                    signature: 10,
                    title: 8,
                    btnText: 4,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    btnText: '点我咨询',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            4: {
                kind: KIND[1],
                cate: CATE[7],
                type: 4,
                order: 6,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'theme', 'role', 'btnText', 'position', 'location', 'deployList'],
                role: ['roleIM'],
                theme: ['', '#000000', '#f0f0f0'],
                limit: {
                    signature: 10,
                    title: 8,
                    btnText: 4,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    btnText: '点我咨询',
                    theme: 3,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            7: {
                kind: KIND[1],
                cate: CATE[7],
                type: 7,
                scene: SCENE[1],
                required: ['title', 'signature', 'role', 'btnText', 'avatar', 'deployList'],
                avatarType: 1,
                role: ['roleIM'],
                suitable: 'qq',
                limit: {
                    signature: 10,
                    title: 8,
                    btnText: 4,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    btnText: '点我咨询',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 70,
                },
            },
            9: {
                kind: KIND[1],
                cate: CATE[7],
                type: 9,
                scene: SCENE[1],
                required: ['title', 'signature', 'role', 'avatar', 'deployList'],
                role: ['roleIM'],
                suitable: 'wx',
                limit: {
                    signature: 26,
                    title: 8,
                },
                isQRcode: 1,
                avatarType: 2,
                defaults: {
                    title: '网页咨询',
                    signature: '长按二维码网页咨询，随时了解最新动态。',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 135,
                },
            },
            12: {
                kind: KIND[1],
                cate: CATE[7],
                type: 12,
                order: 3,
                scene: SCENE[0],
                defaultPosition: POSITION[7],
                required: ['signature', 'role', 'avatar', 'theme', 'location', 'deployList'],
                role: ['roleIM'],
                avatarType: 1,
                theme: ['#ffffff', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                limit: {
                    signature: 32,
                },
                defaults: {
                    signature: '您好，当前有客服在线，请问有什么需要咨询的吗？',
                    location: {
                        v: {
                            type: 3,
                            px: 10,
                        },
                        h: {
                            type: 1,
                            px: 10,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 350,
                    h: 70,
                },
            },
            13: {
                kind: KIND[1],
                cate: CATE[7],
                type: 13,
                order: 4,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['signature', 'role', 'avatar', 'theme', 'location', 'deployList'],
                role: ['roleIM'],
                avatarType: 1,
                theme: ['', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                limit: {
                    signature: 6,
                },
                defaults: {
                    signature: '网页在线咨询',
                    theme: 2,
                    location: {
                        v: {
                            type: 2,
                            px: 0,
                        },
                        h: {
                            type: 3,
                            px: 10,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 106,
                    h: 140,
                },
            },
            14: {
                kind: KIND[1],
                cate: CATE[7],
                type: 14,
                order: 5,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['role', 'theme', 'location', 'middlePage', 'deployList'],
                role: ['roleIM', 'roleQQ'],
                theme: ['', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                defaults: {
                    theme: 2,
                    location: {
                        v: {
                            type: 2,
                            px: 0,
                        },
                        h: {
                            type: 3,
                            px: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 80,
                    h: 160,
                },
            },
            15: {
                kind: KIND[1],
                cate: CATE[7],
                type: 15,
                order: 2,
                scene: SCENE[0],
                required: ['role', 'custom', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    custom: {
                        customType: 2,
                        domId: '',
                        open: 1,
                        customImg: {
                            zoom: 0,
                            url: '',
                            h: {
                                type: 3,
                                px: 0,
                            },
                            v: {
                                type: 3,
                                px: 0,
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            16: {
                kind: KIND[1],
                cate: CATE[7],
                type: 16,
                order: 2,
                scene: SCENE[2],
                required: ['role', 'custom', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    custom: {
                        customType: 2,
                        domId: '',
                        open: 1,
                        customImg: {
                            zoom: 0,
                            url: '',
                            h: {
                                type: 3,
                                px: 0,
                            },
                            v: {
                                type: 3,
                                px: 0,
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            19: {
                kind: KIND[1],
                cate: CATE[7],
                type: 19,
                order: 1,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['theme', 'role', 'location', 'middlePage', 'deployList'],
                theme: ['#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                avatarType: 2,
                role: ['roleIM'],
                defaults: {
                    title: '',
                    signature: '',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    title: 5,
                    signature: 10,
                },
                size: {
                    w: 60,
                    h: 60,
                },
            },
            20: {
                kind: KIND[1],
                cate: CATE[7],
                type: 20,
                order: 1,
                scene: SCENE[2],
                defaultPosition: POSITION[6],
                required: ['theme', 'role', 'location', 'middlePage', 'deployList'],
                theme: ['#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#33cc99'],
                avatarType: 2,
                role: ['roleIM'],
                defaults: {
                    title: '',
                    signature: '',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    title: 5,
                    signature: 10,
                },
                size: {
                    w: 60,
                    h: 60
                }
            }
        },
        /* 语音通话 */
        10: {
            1: {
                kind: KIND[1],
                cate: CATE[10],
                type: 1,
                order: 5,
                scene: SCENE[2],
                required: [
                    'title',
                    'signature',
                    'role',
                    'btnText',
                    'avatar',
                    'location',
                    'deployList',
                ],
                avatarType: 1,
                role: ['roleIM'],
                limit: {
                    signature: 10,
                    title: 8,
                    btnText: 4,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    btnText: '视频咨询',
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            2: {
                kind: KIND[1],
                cate: CATE[10],
                type: 2,
                order: 4,
                scene: SCENE[2],
                defaultPosition: POSITION[9],
                required: ['theme', 'role', 'btnText', 'location', 'deployList'],
                role: ['roleIM'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    btnText: 4,
                },
                defaults: {
                    btnText: '视频咨询',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                pos: 'rb',
                size: {
                    w: 125,
                    h: 39,
                },
            },
            3: {
                kind: KIND[1],
                cate: CATE[10],
                type: 3,
                order: 5,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: [
                    'signature',
                    'theme',
                    'role',
                    'avatar',
                    'location',
                    'deployList',
                ],
                avatarType: 1,
                role: ['roleIM'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    signature: 20,
                },
                defaults: {
                    signature: '客服为您提供视频服务，您无需开启视频',
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            4: {
                kind: KIND[1],
                cate: CATE[10],
                type: 4,
                order: 6,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'avatar', 'theme', 'role', 'location', 'deployList'],
                role: ['roleIM'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    signature: 10,
                    title: 8,
                },
                avatarType: 1,
                defaults: {
                    title: '视频咨询',
                    signature: '服务时间 9:00-20:00',
                    theme: 2,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            5: {
                kind: KIND[1],
                cate: CATE[10],
                type: 5,
                order: 6,
                scene: SCENE[2],
                required: ['title', 'signature', 'role', 'btnText', 'location', 'deployList'],
                role: ['roleIM'],
                limit: {
                    signature: 10,
                    title: 8,
                    btnText: 4,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    btnText: '视频咨询',
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            7: {
                kind: KIND[1],
                cate: CATE[10],
                type: 7,
                scene: SCENE[1],
                required: ['title', 'signature', 'role', 'btnText', 'avatar', 'deployList'],
                avatarType: 1,
                role: ['roleIM'],
                suitable: 'qq',
                limit: {
                    signature: 10,
                    title: 8,
                    btnText: 4,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    btnText: '点我咨询',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 70,
                },
            },
            9: {
                kind: KIND[1],
                cate: CATE[10],
                type: 9,
                scene: SCENE[1],
                required: ['title', 'signature', 'role', 'avatar', 'deployList'],
                role: ['roleIM'],
                suitable: 'wx',
                limit: {
                    signature: 26,
                    title: 8,
                },
                isQRcode: 1,
                avatarType: 2,
                defaults: {
                    title: '网页咨询',
                    signature: '长按二维码网页咨询，随时了解最新动态。',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 135,
                },
            },
            12: {
                kind: KIND[1],
                cate: CATE[10],
                type: 12,
                order: 3,
                scene: SCENE[0],
                defaultPosition: POSITION[7],
                required: ['signature', 'role', 'avatar', 'theme', 'location', 'deployList'],
                role: ['roleIM'],
                avatarType: 1,
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    signature: 32,
                },
                defaults: {
                    signature: '客服为您提供视频服务，您无需开启视频',
                    location: {
                        v: {
                            type: 3,
                            px: 10,
                        },
                        h: {
                            type: 1,
                            px: 10,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 350,
                    h: 70,
                },
            },
            13: {
                kind: KIND[1],
                cate: CATE[10],
                type: 13,
                order: 4,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['title', 'signature', 'role', 'avatar', 'theme', 'location', 'deployList'],
                role: ['roleIM'],
                avatarType: 1,
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    signature: 10,
                    title: 8,

                },
                defaults: {
                    title: '视频咨询',
                    signature: '服务时间 9:00-20:00',
                    theme: 2,
                    location: {
                        v: {
                            type: 2,
                            px: 0,
                        },
                        h: {
                            type: 3,
                            px: 10,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 106,
                    h: 140,
                },
            },
            15: {
                kind: KIND[1],
                cate: CATE[10],
                type: 15,
                order: 2,
                scene: SCENE[0],
                required: ['role', 'custom', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    custom: {
                        customType: 2,
                        domId: '',
                        open: 1,
                        customImg: {
                            zoom: 0,
                            url: '',
                            h: {
                                type: 3,
                                px: 0,
                            },
                            v: {
                                type: 3,
                                px: 0,
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            16: {
                kind: KIND[1],
                cate: CATE[10],
                type: 16,
                order: 2,
                scene: SCENE[2],
                required: ['role', 'custom', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    custom: {
                        customType: 2,
                        domId: '',
                        open: 1,
                        customImg: {
                            zoom: 0,
                            url: '',
                            h: {
                                type: 3,
                                px: 0,
                            },
                            v: {
                                type: 3,
                                px: 0,
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            19: {
                kind: KIND[1],
                cate: CATE[10],
                type: 19,
                order: 1,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['theme', 'role', 'location', 'middlePage', 'deployList'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                avatarType: 2,
                role: ['roleIM'],
                defaults: {
                    title: '',
                    signature: '',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    title: 5,
                    signature: 10,
                },
                size: {
                    w: 60,
                    h: 60,
                },
            },
            20: {
                kind: KIND[1],
                cate: CATE[10],
                type: 20,
                order: 1,
                scene: SCENE[2],
                defaultPosition: POSITION[6],
                required: ['theme', 'role', 'location', 'middlePage', 'deployList'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                avatarType: 2,
                role: ['roleIM'],
                defaults: {
                    title: '',
                    signature: '',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    title: 5,
                    signature: 10,
                },
                size: {
                    w: 60,
                    h: 60,
                },
            },
        },
        /* 视频通话 */
        11: {
            1: {
                kind: KIND[1],
                cate: CATE[11],
                type: 1,
                order: 5,
                scene: SCENE[2],
                required: [
                    'title',
                    'signature',
                    'role',
                    'btnText',
                    'avatar',
                    'location',
                    'deployList',
                ],
                avatarType: 1,
                role: ['roleIM'],
                limit: {
                    signature: 10,
                    title: 8,
                    btnText: 4,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    btnText: '视频咨询',
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            2: {
                kind: KIND[1],
                cate: CATE[11],
                type: 2,
                order: 4,
                scene: SCENE[2],
                defaultPosition: POSITION[9],
                required: ['theme', 'role', 'btnText', 'location', 'deployList'],
                role: ['roleIM'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    btnText: 4,
                },
                defaults: {
                    btnText: '视频咨询',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                pos: 'rb',
                size: {
                    w: 125,
                    h: 39,
                },
            },
            3: {
                kind: KIND[1],
                cate: CATE[11],
                type: 3,
                order: 5,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: [
                    'signature',
                    'theme',
                    'role',
                    'avatar',
                    'location',
                    'deployList',
                ],
                avatarType: 1,
                role: ['roleIM'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    signature: 20,
                },
                defaults: {
                    signature: '客服为您提供视频服务，您无需开启视频',
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            4: {
                kind: KIND[1],
                cate: CATE[11],
                type: 4,
                order: 6,
                scene: SCENE[2],
                defaultPosition: POSITION[8],
                required: ['title', 'signature', 'avatar', 'theme', 'role', 'location', 'deployList'],
                role: ['roleIM'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    signature: 10,
                    title: 8,
                },
                avatarType: 1,
                defaults: {
                    title: '视频咨询',
                    signature: '服务时间 9:00-20:00',
                    theme: 2,
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            5: {
                kind: KIND[1],
                cate: CATE[11],
                type: 5,
                order: 6,
                scene: SCENE[2],
                required: ['title', 'signature', 'role', 'btnText', 'location', 'deployList'],
                role: ['roleIM'],
                limit: {
                    signature: 10,
                    title: 8,
                    btnText: 4,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    btnText: '视频咨询',
                    location: {
                        v: {
                            type: 3,
                            px: 0,
                        },
                        h: {
                            type: 1,
                            px: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 65,
                },
            },
            7: {
                kind: KIND[1],
                cate: CATE[11],
                type: 7,
                scene: SCENE[1],
                required: ['title', 'signature', 'role', 'btnText', 'avatar', 'deployList'],
                avatarType: 1,
                role: ['roleIM'],
                suitable: 'qq',
                limit: {
                    signature: 10,
                    title: 8,
                    btnText: 4,
                },
                defaults: {
                    title: '咨询顾问',
                    signature: '欢迎随时与我们联系',
                    btnText: '点我咨询',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 70,
                },
            },
            9: {
                kind: KIND[1],
                cate: CATE[11],
                type: 9,
                scene: SCENE[1],
                required: ['title', 'signature', 'role', 'avatar', 'deployList'],
                role: ['roleIM'],
                suitable: 'wx',
                limit: {
                    signature: 26,
                    title: 8,
                },
                isQRcode: 1,
                avatarType: 2,
                defaults: {
                    title: '网页咨询',
                    signature: '长按二维码网页咨询，随时了解最新动态。',
                    deployList: [
                        {
                            deployTypeId: DEPLOY[5],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: '100%',
                    h: 135,
                },
            },
            12: {
                kind: KIND[1],
                cate: CATE[11],
                type: 12,
                order: 3,
                scene: SCENE[0],
                defaultPosition: POSITION[7],
                required: ['signature', 'role', 'avatar', 'theme', 'location', 'deployList'],
                role: ['roleIM'],
                avatarType: 1,
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    signature: 32,
                },
                defaults: {
                    signature: '客服为您提供视频服务，您无需开启视频',
                    location: {
                        v: {
                            type: 3,
                            px: 10,
                        },
                        h: {
                            type: 1,
                            px: 10,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 350,
                    h: 70,
                },
            },
            13: {
                kind: KIND[1],
                cate: CATE[11],
                type: 13,
                order: 4,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['title', 'signature', 'role', 'avatar', 'theme', 'location', 'deployList'],
                role: ['roleIM'],
                avatarType: 1,
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                limit: {
                    signature: 10,
                    title: 8,
                },
                defaults: {
                    title: '视频咨询',
                    signature: '服务时间 9:00-20:00',
                    theme: 2,
                    location: {
                        v: {
                            type: 2,
                            px: 0,
                        },
                        h: {
                            type: 3,
                            px: 10,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                size: {
                    w: 106,
                    h: 140,
                },
            },
            15: {
                kind: KIND[1],
                cate: CATE[11],
                type: 15,
                order: 2,
                scene: SCENE[0],
                required: ['role', 'custom', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    custom: {
                        customType: 2,
                        domId: '',
                        open: 1,
                        customImg: {
                            zoom: 0,
                            url: '',
                            h: {
                                type: 3,
                                px: 0,
                            },
                            v: {
                                type: 3,
                                px: 0,
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            16: {
                kind: KIND[1],
                cate: CATE[11],
                type: 16,
                order: 2,
                scene: SCENE[2],
                required: ['role', 'custom', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    custom: {
                        customType: 2,
                        domId: '',
                        open: 1,
                        customImg: {
                            zoom: 0,
                            url: '',
                            h: {
                                type: 3,
                                px: 0,
                            },
                            v: {
                                type: 3,
                                px: 0,
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            19: {
                kind: KIND[1],
                cate: CATE[11],
                type: 19,
                order: 1,
                scene: SCENE[0],
                defaultPosition: POSITION[6],
                required: ['theme', 'role', 'location', 'middlePage', 'deployList'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                avatarType: 2,
                role: ['roleIM'],
                defaults: {
                    title: '',
                    signature: '',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    title: 5,
                    signature: 10,
                },
                size: {
                    w: 60,
                    h: 60,
                },
            },
            20: {
                kind: KIND[1],
                cate: CATE[11],
                type: 20,
                order: 1,
                scene: SCENE[2],
                defaultPosition: POSITION[6],
                required: ['theme', 'role', 'location', 'middlePage', 'deployList'],
                theme: ['#33cc99', '#12b7f5', '#0067ed', '#ff9232', '#ee685d', '#ffcd54'],
                avatarType: 2,
                role: ['roleIM'],
                defaults: {
                    title: '',
                    signature: '',
                    location: {
                        v: {
                            type: 3,
                            px: 20,
                        },
                        h: {
                            type: 3,
                            px: 15,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
                limit: {
                    title: 5,
                    signature: 10,
                },
                size: {
                    w: 60,
                    h: 60,
                },
            },
        },
        12: wpaType12(KIND, CATE, SCENE, DEPLOY, POSITION),
    },
    2: {
        1: {
            16: {
                kind: KIND[2],
                cate: CATE[1],
                type: 16,
                scene: SCENE[3],
                required: ['role', 'deployList'],
                role: ['roleQQ'],
                defaults: {
                    deployList: [
                        {
                            deployTypeId: DEPLOY[0],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
        4: {
            16: {
                kind: KIND[2],
                cate: CATE[4],
                type: 16,
                scene: SCENE[3],
                required: ['role', 'deployList'],
                role: ['roleGROUP'],
                defaults: {
                    deployList: [
                        {
                            deployTypeId: DEPLOY[0],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },

        5: {
            16: {
                kind: KIND[2],
                cate: CATE[5],
                type: 16,
                scene: SCENE[3],
                required: ['role', 'deployList'],
                role: ['roleKFEXT'],
                defaults: {
                    deployList: [
                        {
                            deployTypeId: DEPLOY[0],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },

        7: {
            10: {
                kind: KIND[2],
                cate: CATE[7],
                type: 10,
                scene: SCENE[3],
                required: ['role', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    deployList: [
                        {
                            deployTypeId: DEPLOY[0],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
        10: {
            10: {
                kind: KIND[2],
                cate: CATE[10],
                type: 10,
                scene: SCENE[3],
                required: ['role', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    deployList: [
                        {
                            deployTypeId: DEPLOY[0],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
        11: {
            10: {
                kind: KIND[2],
                cate: CATE[11],
                type: 10,
                scene: SCENE[3],
                required: ['role', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    deployList: [
                        {
                            deployTypeId: DEPLOY[0],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },

    },
    3: {
        1: {
            17: {
                kind: KIND[3],
                cate: CATE[1],
                type: 17,
                scene: SCENE[0],
                required: ['custom', 'role', 'middlePage', 'deployList'],
                role: ['roleQQ'],
                defaults: {
                    btnText: '在线咨询',
                    custom: {
                        customType: 1, // 1 - 自定义DOM 2 - 自定义图片
                        domId: '', // 自定义DOM ID
                        open: 1, // 1 - 当前页打开 2 - 新窗口打开
                        customImg: {
                            zoom: 0, // 0 - 不适应 1 - 水平适应 2 - 上下适应
                            url: '',
                            h: {
                                type: 3, // 1 - 左 2 - 中 3 - 右
                                px: 0, // 偏移量
                            },
                            v: {
                                type: 3, // 1 - 上 2 - 中 3 - 下
                                px: 0, // 偏移量
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            18: {
                kind: KIND[3],
                cate: CATE[1],
                type: 18,
                scene: SCENE[2],
                required: ['custom', 'role', 'middlePage', 'deployList'],
                role: ['roleQQ'],
                defaults: {
                    btnText: '在线咨询',
                    custom: {
                        customType: 1, // 1 - 自定义DOM 2 - 自定义图片
                        domId: '', // 自定义DOM ID
                        open: 1, // 1 - 当前页打开 2 - 新窗口打开
                        customImg: {
                            zoom: 0, // 0 - 不适应 1 - 水平适应 2 - 上下适应
                            url: '',
                            h: {
                                type: 3, // 1 - 左 2 - 中 3 - 右
                                px: 0, // 偏移量
                            },
                            v: {
                                type: 3, // 1 - 上 2 - 中 3 - 下
                                px: 0, // 偏移量
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
        5: {
            21: {
                kind: KIND[3],
                cate: CATE[5],
                type: 21,
                scene: SCENE[0],
                required: ['role', 'custom', 'deployList'],
                role: ['roleKFEXT'],
                defaults: {
                    custom: {
                        customType: 1,
                        domId: '',
                        open: 1,
                        customImg: {
                            zoom: 0,
                            url: '',
                            h: {
                                type: 3,
                                px: 0,
                            },
                            v: {
                                type: 3,
                                px: 0,
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
        7: {
            15: {
                kind: KIND[3],
                cate: CATE[7],
                type: 15,
                scene: SCENE[0],
                required: ['role', 'custom', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    custom: {
                        customType: 1,
                        domId: '',
                        open: 1,
                        customImg: {
                            zoom: 0,
                            url: '',
                            h: {
                                type: 3,
                                px: 0,
                            },
                            v: {
                                type: 3,
                                px: 0,
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            16: {
                kind: KIND[3],
                cate: CATE[7],
                type: 16,
                scene: SCENE[2],
                required: ['role', 'custom', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    custom: {
                        customType: 1,
                        domId: '',
                        open: 1,
                        customImg: {
                            zoom: 0,
                            url: '',
                            h: {
                                type: 3,
                                px: 0,
                            },
                            v: {
                                type: 3,
                                px: 0,
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
        8: {
            20: {
                kind: KIND[3],
                cate: CATE[8],
                type: 20,
                scene: SCENE[0],
                required: ['custom', 'role', 'deployList'],
                role: ['roleQQ'],
                defaults: {
                    custom: {
                        customType: 1, // 1 - 自定义DOM 2 - 自定义图片
                        domId: '', // 自定义DOM ID
                        open: 1, // 1 - 当前页打开 2 - 新窗口打开
                        customImg: {
                            zoom: 0, // 0 - 不适应 1 - 水平适应 2 - 上下适应
                            url: '',
                            h: {
                                type: 3, // 1 - 左 2 - 中 3 - 右
                                px: 0, // 偏移量
                            },
                            v: {
                                type: 3, // 1 - 上 2 - 中 3 - 下
                                px: 0, // 偏移量
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
        12: {
            17: {
                kind: KIND[3],
                cate: CATE[12],
                type: 17,
                order: 2,
                scene: SCENE[0],
                required: ['custom', 'role', 'deployList'],
                role: ['roleWX'],
                defaults: {
                    btnText: '在线咨询',
                    custom: {
                        customType: 1, // 1 - 自定义DOM 2 - 自定义图片
                        domId: '', // 自定义DOM ID
                        open: 1, // 1 - 当前页打开 2 - 新窗口打开
                        customImg: {
                            zoom: 0, // 0 - 不适应 1 - 水平适应 2 - 上下适应
                            url: '',
                            h: {
                                type: 3, // 1 - 左 2 - 中 3 - 右
                                px: 0, // 偏移量
                            },
                            v: {
                                type: 3, // 1 - 上 2 - 中 3 - 下
                                px: 0, // 偏移量
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[1],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
            18: {
                kind: KIND[3],
                cate: CATE[12],
                type: 18,
                order: 2,
                scene: SCENE[2],
                required: ['custom', 'role', 'deployList'],
                role: ['roleWX'],
                defaults: {
                    btnText: '在线咨询',
                    custom: {
                        customType: 1, // 1 - 自定义DOM 2 - 自定义图片
                        domId: '', // 自定义DOM ID
                        open: 1, // 1 - 当前页打开 2 - 新窗口打开
                        customImg: {
                            zoom: 0, // 0 - 不适应 1 - 水平适应 2 - 上下适应
                            url: '',
                            h: {
                                type: 3, // 1 - 左 2 - 中 3 - 右
                                px: 0, // 偏移量
                            },
                            v: {
                                type: 3, // 1 - 上 2 - 中 3 - 下
                                px: 0, // 偏移量
                            },
                            width: 0,
                            height: 0,
                        },
                    },
                    middlePage: {
                        pc: 0,
                        mobile: 1,
                    },
                    deployList: [
                        {
                            deployTypeId: DEPLOY[2],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
    },
    4: {
        10: {
            88: {
                kind: KIND[4],
                cate: CATE[10],
                type: 88,
                scene: SCENE[3],
                required: ['role', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    deployList: [
                        {
                            deployTypeId: DEPLOY[0],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
        11: {
            88: {
                kind: KIND[4],
                cate: CATE[11],
                type: 88,
                scene: SCENE[3],
                required: ['role', 'deployList'],
                role: ['roleIM'],
                defaults: {
                    deployList: [
                        {
                            deployTypeId: DEPLOY[0],
                            deployRemarks: '',
                            deployWebsite: '',
                        },
                    ],
                },
            },
        },
    },
};
